import { Injectable } from '@angular/core';
import { Amplify } from 'aws-amplify';
import {
  fetchAuthSession,
  FetchAuthSessionOptions,
  signInWithRedirect,
  signOut,
} from 'aws-amplify/auth';
import { from, map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolClientId: environment.Auth.userPoolWebClientId,
      userPoolId: environment.Auth.userPoolId,
      loginWith: {
        oauth: {
          domain: environment.Auth.oauth?.domain,
          redirectSignIn: environment.Auth.oauth?.redirectSignIn,
          redirectSignOut: environment.Auth.oauth?.redirectSignOut,
          responseType: environment.Auth.oauth?.responseType,
          scopes: environment.Auth.oauth?.scope,
        },
        email: true,
      },
    },
  },
});
@Injectable({
  providedIn: 'root',
})
export class AuthCognitoService {
  getUserId(): string {
    return (
      localStorage.getItem(
        `CognitoIdentityServiceProvider.${environment.Auth.userPoolWebClientId}.LastAuthUser`,
      ) ?? ''
    );
  }
  signInWithRedirect() {
    return signInWithRedirect();
  }

  fetchAuthSession(options?: FetchAuthSessionOptions) {
    return from(fetchAuthSession(options));
  }

  getAuthorizationToken(options?: FetchAuthSessionOptions): Observable<string> {
    return this.fetchAuthSession().pipe(
      map((session) => {
        const patientId = sessionStorage.getItem('patientId');
        let organizationId = sessionStorage.getItem('organizationId');
        if (!organizationId) {
          const groups = session.tokens?.accessToken.payload['cognito:groups'] ?? [];
          organizationId = (groups as string[])[0];
          sessionStorage.setItem('organizationId', organizationId);
        }
        return `${organizationId ?? 'unknown'} ${patientId ?? 'unknown'} ${session.tokens?.accessToken.toString() || ''}`;
      }),
    );
  }

  signOut() {
    return signOut({ global: true });
  }
}
